import API from "api/axiosInstance";
import { setIsLoading, setListGaji, setMessage, setStatus } from "./index";

export const fetchAllListGaji = (bulan, tahun) => async (dispatch) => {
  dispatch(setIsLoading(true));
  try {
    const response = await API.get(`/api/penggajian`, {
      params: {
        bulan,
        tahun,
      },
    });
    dispatch(setIsLoading(false));
    dispatch(setListGaji(response.data.data));
  } catch (error) {
    dispatch(setIsLoading(false));
    dispatch(setStatus("failed"));
  }
};

export const fetchAddListGaji = (redData) => async (dispatch) => {
  dispatch(setIsLoading(true));
  try {
    const response = await API.post("/api/penggajian", redData);
    dispatch(setMessage(response.data.message));
    dispatch(setStatus("success"));
    dispatch(setIsLoading(false));
  } catch (error) {
    dispatch(setIsLoading(false));
    dispatch(setMessage(error.response.data.error ?? "Ada Kendala di Server"));
    dispatch(setStatus("failed"));
  }
};

export const fetchEditListGaji = (id, redData) => async (dispatch) => {
  dispatch(setIsLoading(true));
  try {
    const response = await API.put(`/api/penggajian/${id}`, redData);
    dispatch(setMessage(response.data.message));
    dispatch(setStatus("success"));
    dispatch(setIsLoading(false));
  } catch (error) {
    dispatch(setIsLoading(false));
    dispatch(setMessage(error.response.data.error ?? "Ada Kendala di Server"));
    dispatch(setStatus("failed"));
  }
};
